var _path, _path2, _path3, _rect, _path4, _path5, _line, _line2, _circle, _line3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 2.8L21.05 3.75L22 4L21.05 4.25L20.8 5.2L20.55 4.25L19.6 4L20.55 3.75Z",
    fill: "#F9AA2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 6.2L22.92 6.68L23.4 6.8L22.92 6.92L22.8 7.4L22.68 6.92L22.2 6.8L22.68 6.68Z",
    fill: "#F9AA2A",
    opacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 6.8L19.28 7.12L19.6 7.2L19.28 7.28L19.2 7.6L19.12 7.28L18.8 7.2L19.12 7.12Z",
    fill: "#FFFFFF",
    opacity: 0.85
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 8.5,
    height: 11.5,
    rx: 1.2,
    stroke: "#F9AA2A",
    strokeWidth: 1.2,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 2V1.15C5.2 0.95 5.35 0.8 5.55 0.8H7.95C8.15 0.8 8.3 0.95 8.3 1.15V2",
    stroke: "#F9AA2A",
    strokeWidth: 1,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.3L5.6 7.4L8.1 5",
    stroke: "#304FFF",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 8.8,
    x2: 9.2,
    y2: 8.8,
    stroke: "#F9AA2A",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    opacity: 0.65
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 10.5,
    x2: 8.5,
    y2: 10.5,
    stroke: "#F9AA2A",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    opacity: 0.65
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8,
    cy: 14.2,
    r: 5.6,
    stroke: "#F9AA2A",
    strokeWidth: 1.35,
    fill: "none"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.8,
    y1: 18.2,
    x2: 23.2,
    y2: 21.6,
    stroke: "#F9AA2A",
    strokeWidth: 1.55,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.8, 14.2) scale(0.0088) translate(-430, -390)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA2A",
    d: "M410.72,531.07c26.9-.22,120.78-3.96,145.36,3.53,2.11.65,3.93,1.96,5.23,3.74,1.93,2.58,2.94,5.09,2.76,9.01-.47,10.8-153.79,226.77-170.18,240.55-5.92.73-12.36,1.02-18.36,1.42-41.44.18-84.15,2.98-125.44.58-8.72-.51-21.01-1.6-26.97-8.87-3.56-4.36-5.38-9.05-4.43-14.79,1.09-6.43,135.9-197.88,151.06-217.69,4.76-6.22,9.7-11.52,16.03-16.25l24.9-1.24h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AA2A",
    d: "M232.33,232.48c49.14-1.78,102.21-.51,151.5.47,14.58.29,37.07,35.98,45.43,47.58,40.71,56.56,80.84,113.59,122.38,169.53,10.1,13.59,18.46,29.51,1.34,38.2-2.33,1.16-4.94,1.71-7.52,1.71l-93.45.18c-21.01.11-43.4,1.2-64.19-1.53-5.85-.76-14.9-11.12-18.61-16.14-49.25-67.32-95.96-136.6-145.14-204.02-12.61-17.3-8.07-25.08,8.21-35.98h.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#304FFF",
    d: "M625.76,538.89c1.93-2.14,4.69-3.38,7.56-3.38,5.27,0,10.07.51,13.49,4.58,7.89,9.41,15.38,20.28,22.5,30.24l44.89,62.88,57.25,79.38c4.87,6.72,10.14,14.9,15.3,21.23,55.83,68.01-14.68,57.03-69.13,58.59-16.03-.04-76.22.47-83.75-6.03-16.9-14.58-86.69-109.23-90.51-125.76,4.36-14.47,64.74-101.85,82.44-121.73h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#304FFF",
    d: "M645.86,232.84c38.57-.4,107.08-3.74,146.88,2.54,8.32,1.31,16.07,17.23,8.43,28.9-13.56,20.65-28.86,41.65-43.47,62.23-30.02,42.05-59.87,84.25-89.49,126.6-8.07,12.65-15.56,29.41-30.68,31-4.36.47-8.58-1.45-11.6-4.65-19.77-21.15-79.53-103.88-84.95-117.19,13.41-27.01,38.57-55.54,55.61-81.56,11.89-18.14,27.15-44.34,49.25-47.83v-.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditAi);
export default __webpack_public_path__ + "static/media/auditAi.e851695668889958d348d18bc99832e9.svg";
export { ForwardRef as ReactComponent };